import Fuse from 'fuse.js'

// The role member a mistyped CSV cell most likely meant — the "did you mean X?"
// hint on unresolved cells. Best fuzzy match by name, or null when nothing's
// close enough.
export function suggestMember(
  raw: string,
  members: { name: string }[],
): string | null {
  const query = raw.trim()
  if (!query || members.length === 0) return null

  const fuse = new Fuse(members, {
    keys: ['name'],
    threshold: 0.4, // lower = stricter; 0.4 tolerates a typo or two, not junk
    ignoreLocation: true,
  })
  return fuse.search(query)[0]?.item.name ?? null
}
